// extracted by mini-css-extract-plugin
export default {"_headding":"Products__headding__kEELs"};